import { CAMPAIGNS_INDEX, CAMPAIGNS_INDEX_SUCCEEDED,
  CAMPAIGN_SELECT_SUCCEEDED } from '../actions'

const initialState = {
  campaigns: [],
  hierarchy: false,
}

const campaignsUpdate = (state = initialState, { type, payload }) => {
  switch (type) {
    case CAMPAIGNS_INDEX:
      return { ...state, ...payload }
    case CAMPAIGNS_INDEX_SUCCEEDED:
      return { ...state, campaigns: payload.campaigns, hierarchy: payload.campaign_tree.hierarchy }
    case CAMPAIGN_SELECT_SUCCEEDED:
      return { ...state, selectedCampaign: payload }
    default:
      return state
  }
}

export default campaignsUpdate



// WEBPACK FOOTER //
// ./src/reducers/campaign.jsx